/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { IObservableArray } from "mobx"
import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { SolutionStatusOnlyDtoModel, SolutionStatusOnlyDtoModelType } from "./SolutionStatusOnlyDtoModel"
import { SolutionStatusOnlyDtoModelSelector } from "./SolutionStatusOnlyDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  pendingSolutions: IObservableArray<SolutionStatusOnlyDtoModelType>;
}

/**
 * ProjectDtoBase
 * auto generated base class for the model ProjectDtoModel.
 */
export const ProjectDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('ProjectDto')
  .props({
    __typename: types.optional(types.literal("ProjectDto"), "ProjectDto"),
    id: types.identifier,
    organizationId: types.union(types.undefined, types.number),
    name: types.union(types.undefined, types.null, types.string),
    startDate: types.union(types.undefined, types.null, types.string),
    source: types.union(types.undefined, types.null, types.string),
    createdOn: types.union(types.undefined, types.string),
    visitGeocodingCount: types.union(types.undefined, types.integer),
    isSynced: types.union(types.undefined, types.null, types.boolean),
    deleted: types.union(types.undefined, types.boolean),
    pendingSolutions: types.union(types.undefined, types.array(MSTGQLRef(types.late((): any => SolutionStatusOnlyDtoModel)))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class ProjectDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get organizationId() { return this.__attr(`organizationId`) }
  get name() { return this.__attr(`name`) }
  get startDate() { return this.__attr(`startDate`) }
  get source() { return this.__attr(`source`) }
  get createdOn() { return this.__attr(`createdOn`) }
  get visitGeocodingCount() { return this.__attr(`visitGeocodingCount`) }
  get isSynced() { return this.__attr(`isSynced`) }
  get deleted() { return this.__attr(`deleted`) }
  pendingSolutions(builder: string | SolutionStatusOnlyDtoModelSelector | ((selector: SolutionStatusOnlyDtoModelSelector) => SolutionStatusOnlyDtoModelSelector) | undefined) { return this.__child(`pendingSolutions`, SolutionStatusOnlyDtoModelSelector, builder) }
}
export function selectFromProjectDto() {
  return new ProjectDtoModelSelector()
}

export const projectDtoModelPrimitives = selectFromProjectDto().organizationId.name.startDate.source.createdOn.visitGeocodingCount.isSynced.deleted
